<template lang='pug'>
#admin.layout( v-if='user && user.email == "admin@bluefaucet.com"' )
  bf-wrapper.max-1200
    router-link( :to='{ name: "admin"}' ) 
      button Admin

    table( v-if='payables.length' )
      tr
        th User
        th Paypal Account
        th Amount
        th Action
      template( v-for='p in payables' )
        tr( v-for='r, i in p.requests')
          td {{ p.username }}
          td {{ p.paypal }}
          td ${{ r.amount }}
          td( v-if='r.paid' ) {{ r.paid.on.toDate() }}
          td( v-else ) 
            button.paid.btn( @click='pay( p, r, i )' ) PAID

</template>

<script>
import api from '@/lib/apis'
import auxiliaries from '@/lib/auxiliaries'
import { db, fc } from '@/main'
import BaseModal from '@/components/modals/base'
import EditBiz from '@/components/forms/biz'
import ModalWrapper from '@/components/modals/wrapper'

export default {
  name: 'payables.view',

  components: {
    BaseModal,
    ModalWrapper,
    EditBiz
  },

  props: {
    user: { required: true }
  },

  data() {
    return {
      refs: [],
      accs: [],
      invs: []
    }
  },

  firestore() {
    return {
      refs: {
        ref: db.collection( 'referrals' )
      },

      accs: db.collection( 'accounts' )
    }
  },

  computed: {
    payables() {
      // let ids = this.refs.map( r => r.by.id )
      // let uids = this.refs.map( r => r.by.user_id )
      // return this.accs.filter( a => uids.includes( a.id ) || ids.includes( a.id ) )
      return this.accs.filter( a => a.requests  && a.requests.length )
    },

    amounts() {
      let amounts = {}
      this.payables.forEach( p => {
        amounts[ p.id ] = []
        let refs = this.refs.filter( r => r.by.id == p.id || r.by.user_id == p.id )
        refs.forEach( r => {
          let acc = null
          if ( r.to ) {
            if ( r.to.id ) acc = this.accs.find( a => a.id == r.to.id )
            else acc = this.accs.find( a => a.email == r.to.email )
          }
          else {
            acc = this.accs.find( a => a.id == r.uid )
          }

          if ( acc ) {
            let invs = this.invs.filter( inv => inv.customer == acc.stripe_id )
            let count = invs.length
            amounts[p.id].push( count * 15 )
          }
          else {
            amounts[p.id].push( 0 )
          }
        })
      })

      return amounts
      
      // let payables = {}

      // this.refs.forEach( r => {
      //   payables[ r.by.user_id || r.by.id ] = []
      //   let acc = null
      //   if ( r.to ) {
      //     if ( r.to.id ) acc = this.accs.find( a => a.id == r.to.id )
      //     else acc = this.accs.find( a => a.email == r.to.email )
      //   }
      //   else {
      //     acc = this.accs.find( a => a.id == r.uid )
      //   }
        
      //   if ( acc ) {
      //     payables[ r.by.user_id || r.by.id ].push( this.invs.filter( inv => inv.customer == acc.stripe_id ).length )
      //   }
      // })

      // return payables
    }
  },

  watch: {
    user( cr, pr ) {
      if ( cr && cr.email != 'admin@bluefaucet.com' ) this.$router.push({ name: 'welcome' })
    }
  },

  methods: {
    pay( p, r, i ) {
      let requests = p.requests
      requests[i].paid = { on: new Date() }
      db.collection( 'accounts' ).doc( p.id ).update({
        requests
      })

      let refs = requests[i].refs
      refs.forEach( r => db.collection( 'referrals' ).doc( r.id ).update({ paid: { on: new Date() }, request: requests[i] }) )
    },

    amount( p ) {
      let amount = this.amounts[p.id].reduce( ( a, b ) => a + b, 0 )
      if ( p.requested) console.log( p.id, p.requested.amount )
      if ( p.requested ) return p.requested.amount
      else return amount
    },

    acc( r ) {
      return this.accs.find( a => a.id == r.by.user_id || a.id == r.by.id ) || {}
    },

    paid( p ) {
      if ( p.paid && p.paid.amount ) 
        if ( !p.requested ) return p.paid.amount
        else return p.requested.amount
      else return 0
    },

    payable( p ) {
      return !p.paid
    },
  },

  created() {
    fc.httpsCallable( 'all_invoices' )().then( r => this.invs = r.data )
    if ( this.user && this.user.email != 'admin@bluefaucet.com' ) this.$router.push({ name: 'welcome' })
  }
}
</script>

<style lang='stylus'>
#admin
  padding-top 92px

  button
    border 1px solid
    text-align center
    padding 5px 10px
    &.paid
      background red
      color white
      border-radius 5px

  .del
    background-color red
    border-radius 5px
    color white
  .enable
    background-color blue
    border-radius 5px
    color white
  .blue
    color blue
    font-weight bold
  .stats
    padding 0px 20px
    font-weight bold
  
  table
    margin 10px 0
    border 1px solid
    text-align left
    tr
      th
        font-weight bold
        padding 10px 10px
        border 1px dotted
        background rgb( 245 245 245 )
      td
        padding 5px 10px
        border 1px dotted
</style>
